










import { Component, Vue } from 'vue-property-decorator';
import { showAxiosErrorMessage } from '@/utils';

import Btn from '@/components/Btn.vue';


@Component({
  name: 'confirm-account-page',
  components: { Btn }
})
export default class ConfirmAccountComponent extends Vue {
  /**
   * Loading data into the system
   */
  public loading = false;

  /**
   * Click event method to confirm the email and send them to the login if something goes wrong
   */
  public async confirmEmail() {
    try {
      this.loading = true;
      if (await this.$store.dispatch('emailVerification', this.$route.params)) {
        this.$router.push('/user/login');
      }
    } catch(ex) {
      showAxiosErrorMessage(ex);
    } finally {
      this.loading = false;
    }
  }
}
